import { buyAction } from 'model/actions/utilities/_buy';
import { formatMessage, randomMessage } from 'model/message';

const ACTION_TYPE = 'BuyAmmo';
const BULK = 10;

const messageText = ({ cost, gain }) => {
  const gainText = randomMessage([
    'usable ammo.',
    'ammo replenished.',
    'stocked up on bullets',
    'Ammo acquired.',
    'Rounds added to inventory'
  ]);
  return formatMessage(gainText, { cost, gain });
};

const gainFor = count => ({ ammo: count });

const config = {
  type: ACTION_TYPE,
  resource: 'ammo',
  label: 'Buy Ammo',
  gainFor,
  messageText
};

const buyAmmo = buyAction({ ...config, hotkey: 'A' });
const buyAmmoBulk = buyAction({ ...config, step: BULK });

export { buyAmmoBulk, buyAmmo as default };
